import {
    FETCH_FORECAST_TRIPS_REQUEST,
    FETCH_FORECAST_TRIPS_SUCCESS,
    FETCH_FORECAST_TRIPS_FAILURE,
    FETCH_FORECAST_ACTIVITIES_REQUEST,
    FETCH_FORECAST_ACTIVITIES_SUCCESS,
    FETCH_FORECAST_ACTIVITIES_FAILURE,
    FETCH_CLAIMS_TRIPS_REQUEST,
    FETCH_CLAIMS_TRIPS_SUCCESS,
    FETCH_CLAIMS_TRIPS_FAILURE,
    FETCH_CLAIMS_ACTIVITIES_REQUEST,
    FETCH_CLAIMS_ACTIVITIES_SUCCESS,
    FETCH_CLAIMS_ACTIVITIES_FAILURE,
    FETCH_POLICIES_TRIPS_REQUEST,
    FETCH_POLICIES_TRIPS_SUCCESS,
    FETCH_POLICIES_TRIPS_FAILURE,
    FETCH_POLICIES_ACTIVITIES_REQUEST,
    FETCH_POLICIES_ACTIVITIES_SUCCESS,
    FETCH_POLICIES_ACTIVITIES_FAILURE,
    FETCH_OBSERVATIONS_ACTIVITIES_REQUEST,
    FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS,
    FETCH_OBSERVATIONS_ACTIVITIES_FAILURE,
    FETCH_ACTIVITY_REFERENCES_REQUEST,
    FETCH_ACTIVITY_REFERENCES_SUCCESS,
    FETCH_ACTIVITY_REFERENCES_FAILURE,
    FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST,
    FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS,
    FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE,
    CREATE_ACTIVITY_REFERENCE_REQUEST,
    CREATE_ACTIVITY_REFERENCE_SUCCESS,
    CREATE_ACTIVITY_REFERENCE_FAILURE,
    UPDATE_ACTIVITY_REFERENCE_REQUEST,
    UPDATE_ACTIVITY_REFERENCE_SUCCESS,
    UPDATE_ACTIVITY_REFERENCE_FAILURE,
    DELETE_ACTIVITY_REFERENCE_REQUEST,
    DELETE_ACTIVITY_REFERENCE_SUCCESS,
    DELETE_ACTIVITY_REFERENCE_FAILURE,
    FETCH_ACTIVITY_SUBCOVERAGES_REQUEST,
    FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS,
    FETCH_ACTIVITY_SUBCOVERAGES_FAILURE,
    FETCH_ACTIVITIES_REQUEST,
    FETCH_ACTIVITIES_SUCCESS,
    FETCH_ACTIVITIES_FAILURE,
    FETCH_ACTIVITY_BY_ID_REQUEST,
    FETCH_ACTIVITY_BY_ID_SUCCESS,
    FETCH_ACTIVITY_BY_ID_FAILURE,
    CREATE_ACTIVITY_REQUEST,
    CREATE_ACTIVITY_SUCCESS,
    CREATE_ACTIVITY_FAILURE,
    UPDATE_ACTIVITY_REQUEST,
    UPDATE_ACTIVITY_SUCCESS,
    UPDATE_ACTIVITY_FAILURE,
    DELETE_ACTIVITY_REQUEST,
    DELETE_ACTIVITY_SUCCESS,
    DELETE_ACTIVITY_FAILURE,
    FETCH_ACTIVITIES_QUOTES_REQUEST,
    FETCH_ACTIVITIES_QUOTES_SUCCESS,
    FETCH_ACTIVITIES_QUOTES_FAILURE,
    FETCH_ACTIVITY_QUOTE_BY_ID_REQUEST,
    FETCH_ACTIVITY_QUOTE_BY_ID_SUCCESS,
    FETCH_ACTIVITY_QUOTE_BY_ID_FAILURE,
    CREATE_ACTIVITY_QUOTE_REQUEST,
    CREATE_ACTIVITY_QUOTE_SUCCESS,
    CREATE_ACTIVITY_QUOTE_FAILURE,
    CREATE_POLICY_REQUEST,
    CREATE_POLICY_SUCCESS,
    CREATE_POLICY_FAILURE,
    FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST,
    FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS,
    FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE,
    CREATE_ACTIVITY_SUBCOVERAGE_REQUEST,
    CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS,
    CREATE_ACTIVITY_SUBCOVERAGE_FAILURE,
    UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST,
    UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS,
    UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE,
    DELETE_ACTIVITY_SUBCOVERAGE_REQUEST,
    DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS,
    DELETE_ACTIVITY_SUBCOVERAGE_FAILURE,
    GENERATE_BULK_TRANSFERS_CSV_REQUEST,
    GENERATE_BULK_TRANSFERS_CSV_SUCCESS,
    GENERATE_BULK_TRANSFERS_CSV_FAILURE,
    GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_REQUEST,
    GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_SUCCESS,
    GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_FAILURE,
    GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_REQUEST,
    GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_SUCCESS,
    GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_FAILURE,
    GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_REQUEST,
    GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_SUCCESS,
    GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_FAILURE,
    FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST,
    FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS,
    FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE,
    DELETE_ACTIVITY_OBSERVATION_REQUEST,
    DELETE_ACTIVITY_OBSERVATION_SUCCESS,
    DELETE_ACTIVITY_OBSERVATION_FAILURE,
} from '../actions/dataActions';
import {
    FETCH_STATISTICS_REQUEST,
    FETCH_STATISTICS_SUCCESS,
    FETCH_STATISTICS_FAILURE,
} from '../actions/statisticsActions';

const initialState = {
    forecasts: {
        trips: { data: null, loading: false, error: null },
        activities: { data: null, loading: false, error: null },
    },
    claims: {
        trips: { data: null, loading: false, error: null },
        activities: { data: null, loading: false, error: null },
    },
    policies: {
        trips: { data: null, loading: false, error: null },
        activities: { data: null, loading: false, error: null },
    },
    observations: {
        activities: { data: null, loading: false, error: null },
    },
    selectedActivityObservation: { data: null, loading: false, error: null },
    deleteActivityObservation: { loading: false, error: null, success: false },
    activityReferences: { data: null, loading: false, error: null },
    activitySubcoverages: { data: null, loading: false, error: null },
    selectedActivitySubcoverage: { data: null, loading: false, error: null },
    createActivitySubcoverage: { loading: false, error: null, success: false },
    updateActivitySubcoverage: { loading: false, error: null, success: false },
    deleteActivitySubcoverage: { loading: false, error: null, success: false },
    selectedReference: { data: null, loading: false, error: null },
    createReference: { loading: false, error: null, success: false },
    updateReference: { loading: false, error: null, success: false },
    deleteReference: { loading: false, error: null, success: false },
    activities: { data: null, loading: false, error: null },
    selectedActivity: { data: null, loading: false, error: null },
    createActivity: { loading: false, error: null, success: false, data: null },
    updateActivity: { loading: false, error: null, success: false },
    deleteActivity: { loading: false, error: null, success: false },
    activitiesQuotes: { data: null, loading: false, error: null },
    selectedActivityQuote: { data: null, loading: false, error: null },
    createActivityQuote: { loading: false, error: null, success: false, data: null },
    createPolicy: { loading: false, error: null, success: false },
    generateBulkTransfersCsv: { loading: false, error: null, success: false, data: null },
    generateBulkTransfersCsvByPolicyCodes: { loading: false, error: null, success: false, data: null },
    generateBulkTransfersCsvEndOfStay: { loading: false, error: null, success: false, data: null },
    generateBulkTransfersCsvEndOfStayByPolicyCodes: { loading: false, error: null, success: false, data: null },
    statistics: { data: null, loading: false, error: null },
};

const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        // Forecasts Trips
        case FETCH_FORECAST_TRIPS_REQUEST:
            return {
                ...state,
                forecasts: {
                    ...state.forecasts,
                    trips: { ...state.forecasts.trips, loading: true, error: null },
                },
            };
        case FETCH_FORECAST_TRIPS_SUCCESS:
            return {
                ...state,
                forecasts: {
                    ...state.forecasts,
                    trips: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_FORECAST_TRIPS_FAILURE:
            return {
                ...state,
                forecasts: {
                    ...state.forecasts,
                    trips: { ...state.forecasts.trips, loading: false, error: action.payload },
                },
            };

        // Forecasts Activities
        case FETCH_FORECAST_ACTIVITIES_REQUEST:
            return {
                ...state,
                forecasts: {
                    ...state.forecasts,
                    activities: { ...state.forecasts.activities, loading: true, error: null },
                },
            };
        case FETCH_FORECAST_ACTIVITIES_SUCCESS:
            return {
                ...state,
                forecasts: {
                    ...state.forecasts,
                    activities: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_FORECAST_ACTIVITIES_FAILURE:
            return {
                ...state,
                forecasts: {
                    ...state.forecasts,
                    activities: { ...state.forecasts.activities, loading: false, error: action.payload },
                },
            };

        // Claims Trips
        case FETCH_CLAIMS_TRIPS_REQUEST:
            return {
                ...state,
                claims: {
                    ...state.claims,
                    trips: { ...state.claims.trips, loading: true, error: null },
                },
            };
        case FETCH_CLAIMS_TRIPS_SUCCESS:
            return {
                ...state,
                claims: {
                    ...state.claims,
                    trips: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_CLAIMS_TRIPS_FAILURE:
            return {
                ...state,
                claims: {
                    ...state.claims,
                    trips: { ...state.claims.trips, loading: false, error: action.payload },
                },
            };

        // Claims Activities
        case FETCH_CLAIMS_ACTIVITIES_REQUEST:
            return {
                ...state,
                claims: {
                    ...state.claims,
                    activities: { ...state.claims.activities, loading: true, error: null },
                },
            };
        case FETCH_CLAIMS_ACTIVITIES_SUCCESS:
            return {
                ...state,
                claims: {
                    ...state.claims,
                    activities: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_CLAIMS_ACTIVITIES_FAILURE:
            return {
                ...state,
                claims: {
                    ...state.claims,
                    activities: { ...state.claims.activities, loading: false, error: action.payload },
                },
            };

        // Policies Trips
        case FETCH_POLICIES_TRIPS_REQUEST:
            return {
                ...state,
                policies: {
                    ...state.policies,
                    trips: { ...state.policies.trips, loading: true, error: null },
                },
            };
        case FETCH_POLICIES_TRIPS_SUCCESS:
            return {
                ...state,
                policies: {
                    ...state.policies,
                    trips: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_POLICIES_TRIPS_FAILURE:
            return {
                ...state,
                policies: {
                    ...state.policies,
                    trips: { ...state.policies.trips, loading: false, error: action.payload },
                },
            };

        // Policies Activities
        case FETCH_POLICIES_ACTIVITIES_REQUEST:
            return {
                ...state,
                policies: {
                    ...state.policies,
                    activities: { ...state.policies.activities, loading: true, error: null },
                },
            };
        case FETCH_POLICIES_ACTIVITIES_SUCCESS:
            return {
                ...state,
                policies: {
                    ...state.policies,
                    activities: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_POLICIES_ACTIVITIES_FAILURE:
            return {
                ...state,
                policies: {
                    ...state.policies,
                    activities: { ...state.policies.activities, loading: false, error: action.payload },
                },
            };

        // Observations Activities
        case FETCH_OBSERVATIONS_ACTIVITIES_REQUEST:
            return {
                ...state,
                observations: {
                    ...state.observations,
                    activities: { ...state.observations.activities, loading: true, error: null },
                },
            };
        case FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS:
            return {
                ...state,
                observations: {
                    ...state.observations,
                    activities: { data: action.payload, loading: false, error: null },
                },
            };
        case FETCH_OBSERVATIONS_ACTIVITIES_FAILURE:
            return {
                ...state,
                observations: {
                    ...state.observations,
                    activities: { ...state.observations.activities, loading: false, error: action.payload },
                },
            };
        // Activity Observation by ID
        case FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST:
            return {
                ...state,
                selectedActivityObservation: { ...state.selectedActivityObservation, loading: true, error: null },
            };
        case FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS:
            return {
                ...state,
                selectedActivityObservation: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE:
            return {
                ...state,
                selectedActivityObservation: { ...state.selectedActivityObservation, loading: false, error: action.payload },
            };
        // Delete Activity Observation
        case DELETE_ACTIVITY_OBSERVATION_REQUEST:
            return {
                ...state,
                deleteActivityObservation: { loading: true, error: null, success: false },
            };
        case DELETE_ACTIVITY_OBSERVATION_SUCCESS:
            return {
                ...state,
                deleteActivityObservation: { loading: false, error: null, success: true },
            };
        case DELETE_ACTIVITY_OBSERVATION_FAILURE:
            return {
                ...state,
                deleteActivityObservation: { loading: false, error: action.payload, success: false },
            };

        // Activity Subcoverages
        case FETCH_ACTIVITY_SUBCOVERAGES_REQUEST:
            return {
                ...state,
                activitySubcoverages: {
                    data: state.activitySubcoverages.data,
                    loading: true,
                    error: null,
                },
            };
        case FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS:
            return {
                ...state,
                activitySubcoverages: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        case FETCH_ACTIVITY_SUBCOVERAGES_FAILURE:
            return {
                ...state,
                activitySubcoverages: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };

        case FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST:
            return {
                ...state,
                selectedActivitySubcoverage: {
                    data: null,
                    loading: true,
                    error: null,
                },
            };
        case FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS:
            return {
                ...state,
                selectedActivitySubcoverage: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };
        case FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE:
            return {
                ...state,
                selectedActivitySubcoverage: {
                    data: null,
                    loading: false,
                    error: action.payload,
                },
            };

        case CREATE_ACTIVITY_SUBCOVERAGE_REQUEST:
            return {
                ...state,
                createActivitySubcoverage: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };
        case CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS:
            return {
                ...state,
                createActivitySubcoverage: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };
        case CREATE_ACTIVITY_SUBCOVERAGE_FAILURE:
            return {
                ...state,
                createActivitySubcoverage: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST:
            return {
                ...state,
                updateActivitySubcoverage: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };
        case UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS:
            return {
                ...state,
                updateActivitySubcoverage: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };
        case UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE:
            return {
                ...state,
                updateActivitySubcoverage: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_ACTIVITY_SUBCOVERAGE_REQUEST:
            return {
                ...state,
                deleteActivitySubcoverage: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };
        case DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS:
            return {
                ...state,
                deleteActivitySubcoverage: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };
        case DELETE_ACTIVITY_SUBCOVERAGE_FAILURE:
            return {
                ...state,
                deleteActivitySubcoverage: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        // Activity References
        case FETCH_ACTIVITY_REFERENCES_REQUEST:
            return {
                ...state,
                activityReferences: { ...state.activityReferences, loading: true, error: null },
            };
        case FETCH_ACTIVITY_REFERENCES_SUCCESS:
            return {
                ...state,
                activityReferences: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITY_REFERENCES_FAILURE:
            return {
                ...state,
                activityReferences: { ...state.activityReferences, loading: false, error: action.payload },
            };

        // Activity Reference By ID
        case FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST:
            return {
                ...state,
                selectedReference: { ...state.selectedReference, loading: true, error: null },
            };
        case FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS:
            return {
                ...state,
                selectedReference: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE:
            return {
                ...state,
                selectedReference: { ...state.selectedReference, loading: false, error: action.payload },
            };

        // Create Activity Reference
        case CREATE_ACTIVITY_REFERENCE_REQUEST:
            return {
                ...state,
                createReference: { loading: true, error: null, success: false },
            };
        case CREATE_ACTIVITY_REFERENCE_SUCCESS:
            return {
                ...state,
                createReference: { loading: false, error: null, success: true },
            };
        case CREATE_ACTIVITY_REFERENCE_FAILURE:
            return {
                ...state,
                createReference: { loading: false, error: action.payload, success: false },
            };

        // Update Activity Reference
        case UPDATE_ACTIVITY_REFERENCE_REQUEST:
            return {
                ...state,
                updateReference: { loading: true, error: null, success: false },
            };
        case UPDATE_ACTIVITY_REFERENCE_SUCCESS:
            return {
                ...state,
                updateReference: { loading: false, error: null, success: true },
                selectedReference: state.selectedReference.data ? {
                    ...state.selectedReference,
                    data: {
                        ...state.selectedReference.data,
                        reference: {
                            ...state.selectedReference.data.reference,
                            ...action.payload,
                        },
                    },
                } : state.selectedReference,
            };
        case UPDATE_ACTIVITY_REFERENCE_FAILURE:
            return {
                ...state,
                updateReference: { loading: false, error: action.payload, success: false },
            };

        // Delete Activity Reference (activitylist)
        case DELETE_ACTIVITY_REFERENCE_REQUEST:
            return {
                ...state,
                deleteReference: { loading: true, error: null, success: false },
            };
        case DELETE_ACTIVITY_REFERENCE_SUCCESS:
            return {
                ...state,
                deleteReference: { loading: false, error: null, success: true },
            };
        case DELETE_ACTIVITY_REFERENCE_FAILURE:
            return {
                ...state,
                deleteReference: { loading: false, error: action.payload, success: false },
            };

        // Activities
        case FETCH_ACTIVITIES_REQUEST:
            return {
                ...state,
                activities: { ...state.activities, loading: true, error: null },
            };
        case FETCH_ACTIVITIES_SUCCESS:
            return {
                ...state,
                activities: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITIES_FAILURE:
            return {
                ...state,
                activities: { ...state.activities, loading: false, error: action.payload },
            };

        // Activity By ID
        case FETCH_ACTIVITY_BY_ID_REQUEST:
            return {
                ...state,
                selectedActivity: { ...state.selectedActivity, loading: true, error: null },
            };
        case FETCH_ACTIVITY_BY_ID_SUCCESS:
            return {
                ...state,
                selectedActivity: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITY_BY_ID_FAILURE:
            return {
                ...state,
                selectedActivity: { ...state.selectedActivity, loading: false, error: action.payload },
            };

        // Update Activity
        case CREATE_ACTIVITY_REQUEST:
            return {
                ...state,
                createActivity: { loading: true, error: null, success: false, data: null },
            };
        case CREATE_ACTIVITY_SUCCESS:
            return {
                ...state,
                createActivity: { loading: false, error: null, success: true, data: action.payload },
            };
        case CREATE_ACTIVITY_FAILURE:
            return {
                ...state,
                createActivity: { loading: false, error: action.payload, success: false, data: null },
            };

        case UPDATE_ACTIVITY_REQUEST:
            return {
                ...state,
                updateActivity: { loading: true, error: null, success: false },
            };
        case UPDATE_ACTIVITY_SUCCESS:
            return {
                ...state,
                updateActivity: { loading: false, error: null, success: true },
                selectedActivity: state.selectedActivity.data ? {
                    ...state.selectedActivity,
                    data: {
                        ...state.selectedActivity.data,
                        activity: action.payload.activity || action.payload,
                    },
                } : state.selectedActivity,
            };
        case UPDATE_ACTIVITY_FAILURE:
            return {
                ...state,
                updateActivity: { loading: false, error: action.payload, success: false },
            };

        case DELETE_ACTIVITY_REQUEST:
            return {
                ...state,
                deleteActivity: { loading: true, error: null, success: false },
            };
        case DELETE_ACTIVITY_SUCCESS:
            return {
                ...state,
                deleteActivity: { loading: false, error: null, success: true },
                activities: {
                    ...state.activities,
                    data: {
                        ...state.activities.data,
                        activities: Array.isArray(state.activities.data?.activities)
                            ? state.activities.data.activities.filter(
                                  (activity) => (activity.activity_id || activity.id) !== action.payload
                              )
                            : [],
                    },
                },
            };
        case DELETE_ACTIVITY_FAILURE:
            return {
                ...state,
                deleteActivity: { loading: false, error: action.payload, success: false },
            };

        case FETCH_ACTIVITIES_QUOTES_REQUEST:
            return {
                ...state,
                activitiesQuotes: { ...state.activitiesQuotes, loading: true, error: null },
            };
        case FETCH_ACTIVITIES_QUOTES_SUCCESS:
            return {
                ...state,
                activitiesQuotes: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITIES_QUOTES_FAILURE:
            return {
                ...state,
                activitiesQuotes: { ...state.activitiesQuotes, loading: false, error: action.payload },
            };

        case FETCH_ACTIVITY_QUOTE_BY_ID_REQUEST:
            return {
                ...state,
                selectedActivityQuote: { ...state.selectedActivityQuote, loading: true, error: null },
            };
        case FETCH_ACTIVITY_QUOTE_BY_ID_SUCCESS:
            return {
                ...state,
                selectedActivityQuote: { data: action.payload, loading: false, error: null },
            };
        case FETCH_ACTIVITY_QUOTE_BY_ID_FAILURE:
            return {
                ...state,
                selectedActivityQuote: { ...state.selectedActivityQuote, loading: false, error: action.payload },
            };

        case CREATE_ACTIVITY_QUOTE_REQUEST:
            return {
                ...state,
                createActivityQuote: { loading: true, error: null, success: false, data: null },
            };
        case CREATE_ACTIVITY_QUOTE_SUCCESS:
            return {
                ...state,
                createActivityQuote: { loading: false, error: null, success: true, data: action.payload },
            };
        case CREATE_ACTIVITY_QUOTE_FAILURE:
            return {
                ...state,
                createActivityQuote: { loading: false, error: action.payload, success: false, data: null },
            };

        case CREATE_POLICY_REQUEST:
            return {
                ...state,
                createPolicy: { loading: true, error: null, success: false },
            };
        case CREATE_POLICY_SUCCESS:
            return {
                ...state,
                createPolicy: { loading: false, error: null, success: true },
            };
        case CREATE_POLICY_FAILURE:
            return {
                ...state,
                createPolicy: { loading: false, error: action.payload, success: false },
            };
        // Réinitialiser le success après un court délai pour permettre le suivi de chaque création
        case 'RESET_POLICY_SUCCESS':
            return {
                ...state,
                createPolicy: { ...state.createPolicy, success: false },
            };

        // Bulk Transfers CSV
        case GENERATE_BULK_TRANSFERS_CSV_REQUEST:
            return {
                ...state,
                generateBulkTransfersCsv: { loading: true, error: null, success: false, data: null },
            };
        case GENERATE_BULK_TRANSFERS_CSV_SUCCESS:
            return {
                ...state,
                generateBulkTransfersCsv: { loading: false, error: null, success: true, data: action.payload },
            };
        case GENERATE_BULK_TRANSFERS_CSV_FAILURE:
            return {
                ...state,
                generateBulkTransfersCsv: { loading: false, error: action.payload, success: false, data: null },
            };

        // Bulk Transfers CSV By Policy Codes
        case GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_REQUEST:
            return {
                ...state,
                generateBulkTransfersCsvByPolicyCodes: { loading: true, error: null, success: false, data: null },
            };
        case GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_SUCCESS:
            return {
                ...state,
                generateBulkTransfersCsvByPolicyCodes: { loading: false, error: null, success: true, data: action.payload },
            };
        case GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_FAILURE:
            return {
                ...state,
                generateBulkTransfersCsvByPolicyCodes: { loading: false, error: action.payload, success: false, data: null },
            };

        // Bulk Transfers CSV End of Stay
        case GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_REQUEST:
            return {
                ...state,
                generateBulkTransfersCsvEndOfStay: { loading: true, error: null, success: false, data: null },
            };
        case GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_SUCCESS:
            return {
                ...state,
                generateBulkTransfersCsvEndOfStay: { loading: false, error: null, success: true, data: action.payload },
            };
        case GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_FAILURE:
            return {
                ...state,
                generateBulkTransfersCsvEndOfStay: { loading: false, error: action.payload, success: false, data: null },
            };

        // Bulk Transfers CSV End of Stay By Policy Codes
        case GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_REQUEST:
            return {
                ...state,
                generateBulkTransfersCsvEndOfStayByPolicyCodes: { loading: true, error: null, success: false, data: null },
            };
        case GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_SUCCESS:
            return {
                ...state,
                generateBulkTransfersCsvEndOfStayByPolicyCodes: { loading: false, error: null, success: true, data: action.payload },
            };
        case GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_FAILURE:
            return {
                ...state,
                generateBulkTransfersCsvEndOfStayByPolicyCodes: { loading: false, error: action.payload, success: false, data: null },
            };

        // Statistics
        case FETCH_STATISTICS_REQUEST:
            return {
                ...state,
                statistics: { ...state.statistics, loading: true, error: null },
            };
        case FETCH_STATISTICS_SUCCESS:
            return {
                ...state,
                statistics: { data: action.payload, loading: false, error: null },
            };
        case FETCH_STATISTICS_FAILURE:
            return {
                ...state,
                statistics: { ...state.statistics, loading: false, error: action.payload },
            };

        default:
            return state;
    }
};

export default dataReducer;

